module.exports = __webpack_public_path__ + "static/media/1.4ba34da0.png";